// extracted by mini-css-extract-plugin
export default {"head":"index_head_eWVxs","headText":"index_headText_wTK9N","headMore":"index_headMore_z4A-a"};